export const INIT_CALENDAR_CURRENT_DATE = {
	year: 0, month: 0, date: 0 
};